import { ImageElement } from '@kontent-ai/gatsby-components';
import tw, { styled } from 'twin.macro';

export const StyledInfoContainer = styled('div', {
  shouldForwardProp: (propName) => propName !== 'direction',
})<{
  direction: Queries.kontent_item_n5050_block_image_and_text_row_elements_image_direction_enum;
}>`
  ${tw`lg:col-span-5`}
  ${tw`flex flex-col justify-center`};
  ${({ direction }) => direction === 'left' && tw`lg:col-start-8`}
`;

export const StyledImageContainer = styled('div', {
  shouldForwardProp: (propName) => propName !== 'direction',
})<{
  direction: Queries.kontent_item_n5050_block_image_and_text_row_elements_image_direction_enum;
}>`
  ${tw`order-first`}
  ${tw`lg:col-start-7 lg:col-span-6`}
  ${tw`flex items-center`}
  ${tw`mb-5 lg:mb-0`}
  ${({ direction }) => direction === 'left' && tw`lg:col-start-1`}
`;

export const StyledImageElement = styled(ImageElement)`
  ${tw`rounded-lg`}
  ${tw`max-h-[500px] lg:max-h-full`}
  ${tw`object-contain`}

  img {
    ${tw`!object-contain`}
  }
`;
